import {Component } from '@angular/core';
import { SharedService } from 'src/app/services/shared-service.service';

@Component({
  selector: 'app-website-footer',
  templateUrl: './website-footer.component.html',
  styleUrls: ['./website-footer.component.css']
})
export class WebsiteFooterComponent {
  smoothScrollToUp(event: MouseEvent) {
  const target = event.target as HTMLElement;
  if (target) {
    target.classList.add('hover-active');
    setTimeout(() => {
      target.classList.remove('hover-active');
    }, 1000); // Remove the hover effect after 1 second
  }

  // Scroll behavior only if it's needed
  const topOfPage = document.querySelector('app-website-header');
  if (topOfPage) {
    topOfPage.scrollIntoView({ behavior: 'smooth' });
  } else {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }
}


}
